/**
 * Builds the `game_over`-only "add opponent to friends" control for
 * `GameStateOverlay.ts`. Split out for the same reason as
 * `gameStateOverlayAvatar.ts` — that file is already over the repo's
 * 200-line convention, so new `game_over`-only logic gets its own home
 * instead of growing the main file further.
 */
import { createAddOpponentControl, type OpponentIdentity } from "./components/AddOpponentControl";
import type { GameStateOverlaySnapshot } from "./GameStateOverlay";

export interface GameOverOpponentControl {
  readonly opponentUserId?: string | null;
  readonly addOpponentControl: HTMLElement | null;
}

/**
 * `opponentUserId` presence is the complete "addable" check — a verified
 * opponent always carries `userId`/`avatarUrl`/`verified` together as a
 * trio (`toSeatedPlayers` in `@bn-games/room-server`), never independently.
 */
export function buildGameOverOpponentControl(
  snapshot: GameStateOverlaySnapshot,
): GameOverOpponentControl {
  const opponentUserId = snapshot.opponentUserId;
  const opponents: readonly OpponentIdentity[] =
    opponentUserId !== null && opponentUserId !== undefined
      ? [{ userId: opponentUserId, name: snapshot.opponentName, avatarUrl: snapshot.opponentAvatarUrl ?? null }]
      : [];
  return { opponentUserId, addOpponentControl: createAddOpponentControl(opponents) };
}
